import { FiCode, FiPenTool, FiTrendingUp, FiShare2 } from 'react-icons/fi';

// Fuente única de las categorías: la usan el gestor de servicios, el detalle de
// usuario y la página de servicios del cliente. Los valores deben coincidir con
// CATEGORIAS_SERVICIO del modelo del servidor.
export const CATEGORIAS = ['desarrollo', 'diseno', 'marketing', 'rrss'];

export const CATEGORIA_META = {
    desarrollo: { label: 'Desarrollo', icon: FiCode },
    diseno: { label: 'Diseño', icon: FiPenTool },
    marketing: { label: 'Marketing', icon: FiTrendingUp },
    rrss: { label: 'RRSS', icon: FiShare2 },
};

export const metaCategoria = (categoria) => CATEGORIA_META[categoria] || CATEGORIA_META.desarrollo;
